__turbopack_context__.v({
  "styledFaqSection": "fWSrhG_styledFaqSection",
});
